export const DASHBOARD = {
  root: 'dashboard-root',
  themeToggle: 'header-theme-toggle',
  projectSelector: 'header-project-selector',
  userMenu: 'header-user-menu',
  metricSoc: 'metric-solar-soc',
  metricWaterAvail: 'metric-water-available',
  metricFlowIn: 'metric-flow-in',
  metricFlowOut: 'metric-flow-out',
  chartSoilMoisture: 'chart-soil-moisture',
  chartFlow: 'chart-flow',
};

export const NAV = {
  dashboard: 'nav-dashboard',
  sensors: 'nav-sensors',
  control: 'nav-control',
  water: 'nav-water',
  energy: 'nav-energy',
  projects: 'nav-projects',
  users: 'nav-users',
  arduino: 'nav-arduino',
};

export const CONTROL = {
  tabsRoot: 'control-tabs',
  tabManual: 'control-tab-manual',
  tabSchedule: 'control-tab-schedule',
  tabAuto: 'control-tab-auto',
  manualToggle: 'control-manual-toggle',
  timeoutInput: 'control-timeout-input',
  saveButton: 'control-save-button',
  autoSoilMin: 'control-auto-soil-min',
  autoSoilMax: 'control-auto-soil-max',
  scheduleAddButton: 'control-schedule-add',
};

export const PROJECTS = {
  newButton: 'projects-new-button',
  nameInput: 'projects-name-input',
  descInput: 'projects-desc-input',
  locationInput: 'projects-location-input',
  submitButton: 'projects-submit-button',
};

export const SENSORS = {
  addButton: 'sensors-add-button',
  nameInput: 'sensors-name-input',
  typeSelect: 'sensors-type-select',
  pinInput: 'sensors-pin-input',
  submitButton: 'sensors-submit-button',
  editButton: 'sensors-edit-button',
  editNameInput: 'sensors-edit-name-input',
  editTypeSelect: 'sensors-edit-type-select',
  editPinInput: 'sensors-edit-pin-input',
  editI2cInput: 'sensors-edit-i2c-input',
  editSubmitButton: 'sensors-edit-submit-button',
};

export const WATER = {
  resetButton: 'water-reset-button',
  dailyLimitInput: 'water-daily-limit-input',
};

export const USERS = {
  inviteEmailInput: 'users-invite-email-input',
  inviteButton: 'users-invite-button',
};

export const ARDUINO = {
  editor: 'arduino-editor',
  saveButton: 'arduino-save-button',
};
